import SettingModuleFactory from '@core/domain/Settings';
import StorageAbstractFactory from '@infrastructure/cache';
import { LanguageShortTypes } from '@core/domain/Settings/interfaces';

const storage = StorageAbstractFactory.createLocalStorage();

export default function onLoginSuccess() {
  return async function () {
    // Ensure last selected user language
    const { language, theme } = await SettingModuleFactory.createGetGeneralSettingsUseCase().execute();
    const newLanguage = await storage.getItem('i18nextLng');

    if (newLanguage && newLanguage !== language) {
      await SettingModuleFactory.createUpdateGeneralSettingsUseCase().execute({ theme, language: newLanguage as LanguageShortTypes });
    }
  };
}
